import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa, Core2Config, PagingResponseModel } from './../../shared';
import { YoutubeContainerModel } from './youtube-container.model';

@Injectable()
export class YoutubeService {

  protected readonly endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'youtube/';

  constructor(protected readonly http: HttpClient) {}

  public getYtubeVideo(countryId: string, visa: ApiVisa): Observable<PagingResponseModel<YoutubeContainerModel>> {
    return this.http.get<PagingResponseModel<YoutubeContainerModel>>(visa.api_domain_url + this.endpoint_path + `query?countryId=${countryId}`, { headers: new HttpHeaders({ authorization: visa.jwt_secret, tenantCode: visa.tenantCode, appId: "none" }) });
  }
}
